import { colorToSurfaceMap } from '../constants/colors-maps';

const PRIMARY_BUTTON_KEY = 'primaryButtonBackgroundColor';
const SECONDARY_BUTTON_KEY = 'secondaryButtonBackgroundColor';
const DEFAULT_BUTTON_NUMBER = 1;

const getButtonNumberFromPreset = (key, preset) => {
  if (!preset) return DEFAULT_BUTTON_NUMBER;

  const { variables } = preset;

  const number = variables[key].match(/\d+/); // Find the first occurrence of a number

  return number ? parseInt(number[0], 10) : DEFAULT_BUTTON_NUMBER;
};

const getAdvancedColorsKeys = (colorKey, activeButtonPreset) => {
  const surface = colorToSurfaceMap[colorKey];
  const primaryButtonNumber = getButtonNumberFromPreset(PRIMARY_BUTTON_KEY, activeButtonPreset);
  const secondaryButtonNumber = getButtonNumberFromPreset(SECONDARY_BUTTON_KEY, activeButtonPreset);

  return {
    wsSiteName: `wsColor${surface}SiteName`,
    wsHeading1: `wsColor${surface}Heading1`,
    wsHeading2: `wsColor${surface}Heading2`,
    wsHeading3: `wsColor${surface}Heading3`,
    wsHeading4: `wsColor${surface}Heading4`,
    wsHeading5: `wsColor${surface}Heading5`,
    wsHeading6: `wsColor${surface}Heading6`,
    wsParagraph: `wsColor${surface}Paragraph`,
    wsBlockquote: `wsColor${surface}Blockquote`,
    wsLinkText: `wsColor${surface}LinkText`,
    wsMarkText: `wsColor${surface}MarkText`,
    wsNavLink: `wsColor${surface}NavLink`,
    wsNavLinkActive: `wsColor${surface}NavLinkActive`,
    wsFeatureIcon: `wsColor${surface}FeatureIcon`,
    wsSocialIcon: `wsColor${surface}SocialIcon`,
    wsContactIcon: `wsColor${surface}ContactIcon`,
    wsPrimaryButtonBackground: `wsColor${surface}PrimaryButton${primaryButtonNumber}Background`,
    wsPrimaryButtonText: `wsColor${surface}PrimaryButton${primaryButtonNumber}Text`,
    wsPrimaryButtonBorder: `wsColor${surface}PrimaryButton${primaryButtonNumber}Border`,
    wsSecondaryButtonBackground: `wsColor${surface}SecondaryButton${secondaryButtonNumber}Background`,
    wsSecondaryButtonText: `wsColor${surface}SecondaryButton${secondaryButtonNumber}Text`,
    wsSecondaryButtonBorder: `wsColor${surface}SecondaryButton${secondaryButtonNumber}Border`,
    wsBorder: `wsColor${surface}Border`,
    wsBlockDivider: `wsColor${surface}BlockDivider`,
    wsInputBorder: `wsColor${surface}InputBorder`,
    wsCheckboxBorder: `wsColor${surface}FormCheckboxBorder`,
    wsFooterNavLinkText: `wsColor${surface}FooterLinkText`,
    wsOverlayBackground: `wsColor${surface}OverlayBackground`,
    wsBlockBackground: `wsColor${surface}Background`,
    wsDecorationBackground: `wsColor${surface}DecorationBackground`,
    wsHeaderPhone: `wsColor${surface}HeaderPhone`,
  };
};

export default getAdvancedColorsKeys;
